import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\GetAssetsForPeriodController::__invoke
* @see app/Http/Controllers/Planning/GetAssetsForPeriodController.php
* @route '/api/planning/assets-for-period'
*/
const GetAssetsForPeriodController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAssetsForPeriodController.url(options),
    method: 'get',
})

GetAssetsForPeriodController.definition = {
    methods: ["get","head"],
    url: '/api/planning/assets-for-period',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Planning\GetAssetsForPeriodController::__invoke
* @see app/Http/Controllers/Planning/GetAssetsForPeriodController.php
* @route '/api/planning/assets-for-period'
*/
GetAssetsForPeriodController.url = (options?: RouteQueryOptions) => {
    return GetAssetsForPeriodController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\GetAssetsForPeriodController::__invoke
* @see app/Http/Controllers/Planning/GetAssetsForPeriodController.php
* @route '/api/planning/assets-for-period'
*/
GetAssetsForPeriodController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAssetsForPeriodController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Planning\GetAssetsForPeriodController::__invoke
* @see app/Http/Controllers/Planning/GetAssetsForPeriodController.php
* @route '/api/planning/assets-for-period'
*/
GetAssetsForPeriodController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAssetsForPeriodController.url(options),
    method: 'head',
})

export default GetAssetsForPeriodController